import React from 'react';
import { browserHistory, Link } from 'react-router';
import { Button } from 'react-bootstrap';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import PageHeader from '../PageHeader/PageHeader';
import SectionHeading from '../SectionHeading/SectionHeading';
import RadioGroup from '../RadioGroup/RadioGroup';
import './Change.scss';
import DashboardConstants from '../myaccount/DashboardConstants';
import PlanUtils from '../../services/PlanService';
import PlanDetails from '../Plans/PlanDetails/PlanDetails';
import PlanData from '../../common/PlanDetails';
import PlanType from '../../common/PlanType';
import SessionCheckerContainer from '../../redux/containers/SessionCheckerContainer';

const getPlanDetails = (label) => {
  const plan = PlanUtils.getPlanData(label);
  return { planStateText: 'Current Speed', ...plan };
};

const getLosUri = () => {
  const uri = PlanData.legalOfferSummaryLink;
  return uri;
};

const getHeading = (currentPlanLabel) => {
  const currentPlan = PlanUtils.getPlanData(currentPlanLabel);
  const optionType = (currentPlan.type === PlanType.WVS || currentPlan.type === PlanType.EUBA) ? 'Fibre' : 'speed';
  return (
    <p className="plan-speed-description">
      These are the {optionType} options available at your address. For a full
      list of plans and pricing,{' '}
      <a
        href="https://www.skinny.co.nz/broadband"
        target="_blank"
        rel="noopener noreferrer"
      >
        see here
      </a>
    </p>
  );
};

const Change = reduxForm({
  form: 'checkout',
  destroyOnUnmount: false,
  handleNext: () => {
    browserHistory.push(`/confirm-change/${DashboardConstants.CHANGE_SPEED}`);
  }
})(props => (
  <main>
    <SessionCheckerContainer />
    <PageHeader title={DashboardConstants.CHANGE_SPEED} />
    <div className="container">
      <div>
        <SectionHeading
          number={1}
          title={'Change your speed'}
          titleClassName={'choose-speed-title'}
          numberClassName={'choose-speed-heading-number'}
        />
        <PlanDetails {...getPlanDetails(props.customerInfo.currentPlan)} />
        {getHeading(props.customerInfo.currentPlan)}
        <RadioGroup
          name={'plan'}
          radioButtons={PlanUtils.mapPlansToRadios(
            PlanUtils.getOtherPlans(props.availablePlans, props.customerInfo.currentPlan),
            props.customerInfo.currentPlan, true)
          }
          selectedValue={props.selectedPlanId}
          onChange={props.setSelectedPlan}
          underline
        />
      </div>
      <div className="los-link">
        <Link
          target="_blank"
          to={getLosUri()}
          rel="noopener noreferrer"
        > Legal offer summary</Link> for your new plan.
      </div>
      <div>
        If you or someone at your place is vulnerable due to medical,
        disability, or safety reasons, visit{' '}
        <a
          href="https://www.skinny.co.nz/vulnerable"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.skinny.co.nz/vulnerable
        </a>
      </div>
      <div className="button-container">
        <Button
          type="submit"
          id="change-continue"
          onClick={props.handleNext}
        >
          Continue
        </Button>
        <Button
          id="change-back"
          className="btn btn-default btn-secondary"
          onClick={() => browserHistory.push('/dashboard')}
        >
          Back
        </Button>
      </div>
    </div>
  </main>
));

Change.propTypes = {
  customerInfo: PropTypes.object,
  availablePlans: PropTypes.arrayOf(PropTypes.object),
  selectedPlanId: PropTypes.string,
  ufbAvailable: PropTypes.bool,
  setSelectedPlan: PropTypes.func
};

export default Change;



/** WEBPACK FOOTER **
 ** ./src/components/Change/Change.js
 **/